<template>
  <div
    v-if="summary.showDetails"
    style="display: flex; flex-direction: column; min-width: 145px"
    class="mt-1"
  >
    <div class="d-flex align-items-center summary-details" style="gap: 5px">
      <VueCustomTooltip
        :label="$ml.get('lowImpact')"
        :multiline="true"
        size="is-small"
      >
        <div class="low-details scare-details"></div>
      </VueCustomTooltip>
      <span style="width: 50px">{{ $ml.get("low") }}:</span>
      <span>
        {{
          currency === "BRL"
            ? $utils.convertMoney(data.bountyDetails.low)
            : $utils.convertDollar(data.bountyDetails.low)
        }}</span
      >
    </div>

    <div class="d-flex align-items-center summary-details" style="gap: 5px">
      <VueCustomTooltip
        :label="$ml.get('mediumImpact')"
        :multiline="true"
        size="is-small"
      >
        <div class="low-medium scare-details"></div>
      </VueCustomTooltip>
      <span style="width: 50px">{{ $ml.get("medium") }}:</span>
      <span>
        {{
          currency === "BRL"
            ? $utils.convertMoney(data.bountyDetails.medium)
            : $utils.convertDollar(data.bountyDetails.medium)
        }}</span
      >
    </div>

    <div class="d-flex align-items-center summary-details" style="gap: 5px">
      <VueCustomTooltip
        :label="$ml.get('highImpact')"
        :multiline="true"
        size="is-small"
      >
        <div class="low-high scare-details"></div>
      </VueCustomTooltip>
      <span style="width: 50px">{{ $ml.get("high") }}:</span>
      <span>
        {{
          currency === "BRL"
            ? $utils.convertMoney(data.bountyDetails.high)
            : $utils.convertDollar(data.bountyDetails.high)
        }}</span
      >
    </div>

    <div class="d-flex align-items-center summary-details" style="gap: 5px">
      <VueCustomTooltip
        :label="$ml.get('criticalImpact')"
        :multiline="true"
        size="is-small"
      >
        <div class="low-critical scare-details"></div>
      </VueCustomTooltip>
      <span style="width: 50px">{{ $ml.get("critical") }}: </span>
      <span>
        {{
          currency === "BRL"
            ? $utils.convertMoney(data.bountyDetails.critical)
            : $utils.convertDollar(data.bountyDetails.critical)
        }}</span
      >
    </div>
  </div>
</template>
<script>
export default {
  name: "BountyDetails",
  props: ["data", "currency", "summary"],
};
</script>
<style scoped>
.summary-details {
  margin: 3px 0px;
  border-top: 1px solid #cccccc85;
  font-size: 0.9rem;
  font-weight: 400;
  padding: 2px 0px;
}
.scare-details {
  width: 18px;
  height: 6px;
  border-radius: 4px;
}
.low-details {
  background: #f1f1f1;
}
.low-medium {
  background: #fff7da;
}
.low-high {
  background: #fec5b0;
}
.low-critical {
  background: #c6a4f3;
}
</style>
